import React, { useEffect } from 'react';
import { Link, useLocation } from "react-router-dom";

export default function AdminSideBar() {

    const location = useLocation();
    useEffect(() => {
        const script = document.createElement('script');
        script.src = '/assets/js/kaiadmin.min.js';
        script.async = true;
        document.body.appendChild(script);

        return () => {
            document.body.removeChild(script);
        };
    }, []);

    return (
        <>
            <div className="sidebar" data-background-color="dark">
                <div className="sidebar-logo">
                    <div className="logo-header" data-background-color="dark">
                    <img
                    src="/assets/img/logo2.png"
                    alt="navbar brand"
                    className="navbar-brand"
                    height={40}
                /> 
                        <div className="nav-toggle">
                            <button className="btn btn-toggle toggle-sidebar">
                                <i className="gg-menu-right" />
                            </button>
                            <button className="btn btn-toggle sidenav-toggler">
                                <i className="gg-menu-left" />
                            </button>
                        </div>
                        <button className="topbar-toggler more">
                            <i className="gg-more-vertical-alt" />
                        </button>
                    </div>
                </div>
                <div className="sidebar-wrapper scrollbar scrollbar-inner">
                    <div className="sidebar-content">
                        <ul className="nav nav-secondary">
                            <li className={location.pathname=="/admin"?
                                "nav-item active"
                                :
                                "nav-item"
                            }>
                                <Link to={"/admin"}>
                                    <i className="fas fa-home" />
                                    <p>Dashboard</p>
                                </Link>
                            </li>
                            <li className="nav-section">
                                <span className="sidebar-mini-icon">
                                    <i className="fa fa-ellipsis-h" />
                                </span>
                                <h4 className="text-section">Manage</h4>
                            </li>
                            <li className={location.pathname=="/admin/trainers"?
                                "nav-item active"
                                :
                                "nav-item"
                            }>
                                <Link to="/admin/trainers">
                                    <i className="fas fa-chalkboard-teacher" /> 
                                    <p>Trainers</p>
                                </Link>
                            </li>
                            <li className={location.pathname=="/admin/students"?
                                "nav-item active"
                                :
                                "nav-item"
                            }>
                                <Link to="/admin/students">
                                    <i className="fas fa-user-graduate" />  
                                    <p>Students</p>
                                </Link>
                            </li>

                            <li className={location.pathname=="/admin/batches"?
                                "nav-item active"
                                :
                                "nav-item"
                            }>
                                <Link to="/admin/batches">
                                    <i className="fas fa-layer-group" />
                                    <p>Batches</p>
                                </Link>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </>
    );
}
